import { useTranslate } from '@tolgee/react';
import { Modal } from 'antd';
import useCrud from 'hooks/useCrud';
import { overview } from '../OutStock/api';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

export const useOutStockDispatch = () => {
  const { t } = useTranslate();
  const { qaEnable: isEnterpriseEdition } = useOrgConfigStateValue();

  const {
    item: dispatchOverview,
    setItem: setDispatchOverview,
    fetch: fetchOverview,
  } = useCrud({
    read: overview,
  });

  const remainCount = dispatchOverview
    ? dispatchOverview.todayLimit - dispatchOverview.todayDispatch
    : undefined;

  const cannotDispatch =
    remainCount === undefined || remainCount > 0
      ? undefined
      : () => {
          Modal.confirm({
            closable: true,
            maskClosable: true,
            title: t('aide.发送次数不足'),
            content: isEnterpriseEdition
              ? t('aide.今日已无发送次数')
              : t('aide.今日已无发送次数，升级成企业版获得更多发送次数'),
            cancelButtonProps: { style: { display: 'none' } },
            okButtonProps: { style: { display: 'none' } },
          });
        };

  return {
    remainCount,
    dispatchOverview,
    cannotDispatch,
    setDispatchOverview,
    fetchOverview,
  };
};
